import { createAction, props } from '@ngrx/store';
import { CandidateDataFlowItem } from '../../shared/models/data-flow-api.model';

export interface DataFlowFilters {
  pageSize: number;
  pageNumber: number;
  candidateName?: string;
  serviceType?: string;
  progress?: string; // opened | unopened
  slaPriority?: boolean;
  stage?: string;
  status?: string;
  isRequestdocumentUploaded?: boolean;
}

export const getDataFlowsRequest = createAction(
  '[DataFlow] Get Data Flows Request',
  props<{ filters: DataFlowFilters }>()
);

export const setDataFlowFilters = createAction(
  '[DataFlow] Set Filters',
  props<{ filters: DataFlowFilters }>()
);

export const getDataFlowsSuccess = createAction(
  '[DataFlow] Get Data Flows Success',
  props<{ data: CandidateDataFlowItem[]; total: number }>()
);

export const getDataFlowsFailure = createAction(
  '[DataFlow] Get Data Flows Failure',
  props<{ message: string }>()
);

export const getDataFlowByIdRequest = createAction(
  '[DataFlow] Get Data Flow By Id Request',
  props<{ id: string }>()
);

export const getDataFlowByIdSuccess = createAction(
  '[DataFlow] Get Data Flow By Id Success',
  props<{ data: any }>()
);

export const getDataFlowByIdFailure = createAction(
  '[DataFlow] Get Data Flow By Id Failure',
  props<{ message: string }>()
);

export const clearSelectedDataFlow = createAction(
  '[DataFlow] Clear Selected Data Flow'
);

// Update Data Flow
export const updateDataFlowRequest = createAction(
  '[DataFlow] Update Data Flow Request',
  props<{
    id: string;
    payload: {
      status?: string;
      dataflowReportURL?: string;
      licensingIssuanceExam?: string;
      /** Numeric amount only; backend expects a number at baseFee / baseFee.amount. */
      baseFee?: number;
      additionalFee?: number;
      additionalFeesReason?: string;
      verifyDocument?: string | null;
      ProfessionalLicense?: string | null;
    };
  }>()
);

export const updateDataFlowSuccess = createAction(
  '[DataFlow] Update Data Flow Success',
  props<{ data: any }>()
);

export const updateDataFlowFailure = createAction(
  '[DataFlow] Update Data Flow Failure',
  props<{ message: string }>()
);

// Add Message to Data Flow
export const addMessageRequest = createAction(
  '[DataFlow] Add Message Request',
  props<{ id: string; message: string }>()
);

export const addMessageSuccess = createAction(
  '[DataFlow] Add Message Success',
  props<{ data: any }>()
);

export const addMessageFailure = createAction(
  '[DataFlow] Add Message Failure',
  props<{ message: string }>()
);

// Request Documents
export const requestDocumentsRequest = createAction(
  '[DataFlow] Request Documents Request',
  props<{ id: string; documents: { documentName: string; instructions: string }[] }>()
);

export const requestDocumentsSuccess = createAction(
  '[DataFlow] Request Documents Success',
  props<{ data: any }>()
);

export const requestDocumentsFailure = createAction(
  '[DataFlow] Request Documents Failure',
  props<{ message: string }>()
);

// Upload Verified Report
export const uploadVerifiedReportRequest = createAction(
  '[DataFlow] Upload Verified Report Request',
  props<{ id: string; file: File }>()
);

export const uploadVerifiedReportSuccess = createAction(
  '[DataFlow] Upload Verified Report Success',
  props<{ data: any }>()
);

export const uploadVerifiedReportFailure = createAction(
  '[DataFlow] Upload Verified Report Failure',
  props<{ message: string }>()
);

// Submit License Submission
export const submitLicenseSubmissionRequest = createAction(
  '[DataFlow] Submit License Submission Request',
  props<{
    id: string;
    serviceFee: number;
    feeReason: string;
    invoiceFile: File | null;
    professionalLicenseFile: File | null;
    documents: { documentName: string; instructions: string }[];
  }>()
);

export const submitLicenseSubmissionSuccess = createAction(
  '[DataFlow] Submit License Submission Success',
  props<{ data: any }>()
);

export const submitLicenseSubmissionFailure = createAction(
  '[DataFlow] Submit License Submission Failure',
  props<{ message: string }>()
);

// Upload Official Invoice (License Submission)
export const uploadOfficialInvoiceRequest = createAction(
  '[DataFlow] Upload Official Invoice Request',
  props<{ id: string; file: File }>()
);

export const uploadOfficialInvoiceSuccess = createAction(
  '[DataFlow] Upload Official Invoice Success',
  props<{ data: any }>()
);

export const uploadOfficialInvoiceFailure = createAction(
  '[DataFlow] Upload Official Invoice Failure',
  props<{ message: string }>()
);

// Add Exam Booking
export const addExamBookingRequest = createAction(
  '[DataFlow] Add Exam Booking Request',
  props<{
    id: string;
    examCenterName: string;
    location: string;
    examFee: number;
    timeZone: string;
    slots: { fromDate: string; toDate: string }[];
    documents: { documentName: string; instructions: string }[];
  }>()
);

export const addExamBookingSuccess = createAction(
  '[DataFlow] Add Exam Booking Success',
  props<{ data: any }>()
);

export const addExamBookingFailure = createAction(
  '[DataFlow] Add Exam Booking Failure',
  props<{ message: string }>()
);

// Mark Request Document As Uploaded (Reviewed)
export const markDocumentAsUploadedRequest = createAction(
  '[DataFlow] Mark Document As Uploaded Request',
  props<{ id: string; filters: DataFlowFilters }>()
);

export const markDocumentAsUploadedSuccess = createAction(
  '[DataFlow] Mark Document As Uploaded Success',
  props<{ data: any }>()
);

export const markDocumentAsUploadedFailure = createAction(
  '[DataFlow] Mark Document As Uploaded Failure',
  props<{ message: string }>()
);

// Update Exam Booking Status
export const updateExamBookingStatusRequest = createAction(
  '[DataFlow] Update Exam Booking Status Request',
  props<{
    dataFlowId: string;
    bookingId: string;
    status: 'exam_pass' | 'exam_fail';
  }>()
);

export const updateExamBookingStatusSuccess = createAction(
  '[DataFlow] Update Exam Booking Status Success',
  props<{ data: any }>()
);

export const updateExamBookingStatusFailure = createAction(
  '[DataFlow] Update Exam Booking Status Failure',
  props<{ message: string }>()
);
